import React from 'react'

const ErrorMessage = ({ message }) => <h2>{ message }</h2>

export default ErrorMessage; 